import { handleActions } from "redux-actions";

import { EVENTS_SUCCESS, EVENTS_REQUEST, EVENTS_FAILURE } from "constants/action-types";

export interface IState {
    results: any[];
    isFetching: boolean;
    error?: any;
}

const initialState: IState = {
    results: [],
    isFetching: false,
    error: undefined,
};

const eventsReducer = handleActions<IState, any>(
    {
        [EVENTS_REQUEST]: (state: IState, { meta = {} }: any) => ({
            results: meta.reset ? [] : state.results,
            isFetching: true,
            error: undefined,
        }),
        [EVENTS_SUCCESS]: (state: IState, { payload, meta = {} }: any) => {
            return Object.assign({}, state, {
                isFetching: !!meta.loadingMore,
                results: state.results.concat(payload),
            });
        },
        [EVENTS_FAILURE]: (state: IState, { payload }) => ({
            results: [],
            isFetching: false,
            error: payload,
        }),
    },
    initialState
);

export default eventsReducer;
